import { useState, useEffect } from "react";
import { useIpAddress } from "../utilities/useIpAddress";
import Header from "./Header";
import MapComponent from "./MapComponent";
import SearchComponent from "./SearchComponent";
import DataDisplay from "./DataDisplay";
import Background from "./Background";
import "../css/App.css";

const App: React.FC = () => {
  const [ipAddress, setIpAddress] = useState<string>("");
  const [coordinates, setCoordinates] = useState<[number, number] | null>(null);

  const { data, loading, error } = useIpAddress(ipAddress);

  useEffect(() => {
    setCoordinates([data?.location.lat ?? 0, data?.location.lng ?? 0]);
  }, [data]);

  function handleSubmit(ip: string) {
    setIpAddress(ip);
  }

  return (
    <div>
      <div className="foreground-container container">
        <Header />
        <SearchComponent
          handleSubmit={handleSubmit}
          ipAddress={ipAddress}
        />
        <DataDisplay
          data={data}
          loading={loading}
          error={error}
        />
      </div>
      <Background />
      <MapComponent
        loading={loading}
        coordinates={coordinates}
      />
    </div>
  );
};

export default App;
